<template>
  <div style="display: contents">
    <b-row class="my-3">
      <b-col>
        <h6 v-translate>Invoicing info</h6>
        <b-row>
          <b-col md="3">
            <b-form-group>
              <b-form-select
                id="isCompany"
                v-model="client.isCompany"
                size="sm"
                >
                  <b-form-select-option :value="null" disabled v-translate>-- select --</b-form-select-option>
                  <b-form-select-option :value="false" disabled v-transalte>Person</b-form-select-option>
                  <b-form-select-option :value="true" disabled v-translate>Bussiness</b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="3" v-if="client.isCompany">
              <b-form-group>
              <b-form-input
                type="text"
                name="client_vat"
                :placeholder="$gettext('vat no.')"
                class="form-control form-control-sm"
                v-model="client.vatNo"
                size="sm"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="2" v-if="client.isCompany">
            <b-button size="sm" variant="success" v-translate>Search</b-button>
          </b-col>
          <b-col sm="4"  v-if="client.isCompany">
            <b-form-group>
              <b-form-input
                type="text"
                name="client_comapanyName"
                :placeholder="$gettext('Company name')"
                class="form-control form-control-sm"
                v-model="client.companyName"
                size="sm"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="1" v-if="!client.isCompany">
            <b-form-group>
              <b-form-select
                id="client_title"
                v-model="client.title"
                size="sm"
                >
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="4" v-if="!client.isCompany">
            <b-form-group>
              <b-form-input
                type="text"
                name="client_first_name"
                :placeholder="$gettext('First Name*')"
                class="form-control form-control-sm"
                v-model="client.firstName"
                size="sm"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="4" v-if="!client.isCompany">
            <b-form-group>
              <b-form-input
                type="text"
                name="client_last_name"
                :placeholder="$gettext('Last Name*')"
                class="form-control form-control-sm"
                v-model="client.lastName"
                size="sm"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row> <!-- v-if="!client.clientCode"-->
          <b-col md="6">
            <b-row>
              <b-col sm="12">
                <b-form-group>
                  <b-form-input
                    type="text"
                    name="client_cnp"
                    :placeholder="$gettext('personal number')"
                    class="form-control form-control-sm"
                    v-model="client.cnp"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group>
                  <b-form-input
                    type="text"
                    name="client_id_info"
                    :placeholder="$gettext('passport')"
                    class="form-control form-control-sm"
                    v-model="client.idInfo"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group>
                  <b-form-input
                    type="text"
                    name="client_email"
                    :placeholder="$gettext('email')"
                    class="form-control form-control-sm"
                    v-model="client.email"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group>
                  <b-form-input
                    type="text"
                    name="client_tel"
                    :placeholder="$gettext('telephone')"
                    class="form-control form-control-sm"
                    v-model="client.tel"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row>
              <b-col sm="12">
                <b-form-group>
                  <b-form-input
                    type="text"
                    name="client_address1"
                    :placeholder="$gettext('Address 1')"
                    class="form-control form-control-sm"
                    v-model="client.address1"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group>
                  <b-form-input
                    type="text"
                    name="client_address2"
                    :placeholder="$gettext('Address 2')"
                    class="form-control form-control-sm"
                    v-model="client.address2"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group>
                  <b-form-input
                    type="text"
                    name="client_city"
                    :placeholder="$gettext('City')"
                    class="form-control form-control-sm"
                    v-model="client.city"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group>
                  <b-form-input
                    type="text"
                    name="client_county"
                    :placeholder="$gettext('County')"
                    class="form-control form-control-sm"
                    v-model="client.county"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'InvoicingInfoForm',
  props: ['value'],
  data () {
    return {
      companySearchDone: false,
      client: this.value
    }
  }
}
</script>
